"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * Returns a curried function of `f`
 *
 * @example
 * ```ts
 * const add = (a: number, b: number): number => a + b
 *
 * const curried = curry(add)
 * const add10 = curried(10)
 * console.log(add10(5)) // 15
 * console.log(curried(3, 4)) // 7
 * ```
 */
function curry(f) {
    var arity = f.length;
    return (function resolver() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var memory = tslib_1.__spreadArray([], tslib_1.__read(args), false);
        return function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var local = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(memory), false), tslib_1.__read(innerArgs), false);
            var next = local.length >= arity ? f : resolver;
            return next.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(local), false));
        };
    })();
}
exports.default = curry;
//# sourceMappingURL=curry.js.map